import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet'; // ✅ SEO helmet
import DesignImage from '../../assets/images/design.png';
import AnimationImage from '../../assets/images/animation.png';
import './HeroSection.css';
import Work from './Work.js';

// Lazy loaded components
const LearningSection = lazy(() => import('./LearningSection.js'));
const Slider = lazy(() => import('../../components/Slider/Slider.jsx'));
const LearningExp = lazy(() => import('./LearningExp.js'));
const MovingAnimation = lazy(() => import('./MovingAnimation.js'));
const Footer = lazy(() => import('../../components/Footer/Footer'));

const FeatureBox = ({ title, description, buttonText }) => (
  <div className="feature-box">
    <h5>{title}</h5>
    <p>{description}</p>
    <button className="feature-btn">{buttonText}</button>
  </div>
);

const HeroSection = () => {
  return (
    <div className="landing-page">
      {/* ✅ SEO Tags for Homepage */}
      <Helmet>
        <title>Inelf – Interactive Learning That Makes You Successful</title>
        <meta
          name="description"
          content="Inelf is your one-stop platform for hands-on learning in HTML, CSS, Crypto, IELTS and more. Enjoy interactive lessons, real projects, and visual guidance."
        />
        <meta
          name="keywords"
          content="Inelf, learn HTML, learn CSS, Crypto trading course, IELTS preparation, interactive learning platform"
        />
        <link rel="canonical" href="https://inelf.com/" />

        {/* Open Graph (for Facebook, LinkedIn etc.) */}
        <meta property="og:title" content="Inelf – Interactive Learning That Makes You Successful" />
        <meta property="og:description" content="Explore interactive courses on web development, trading, and IELTS – built for learners who love creativity and clarity." />
        <meta property="og:image" content="https://res.cloudinary.com/dynzcnjqf/image/upload/v1752399865/logo512_nxwint.png" />
        <meta property="og:url" content="https://inelf.com/" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Inelf – Interactive Learning That Makes You Successful" />
        <meta name="twitter:description" content="Explore interactive courses on web development, trading, and IELTS – built for learners who love creativity and clarity." />
        <meta name="twitter:image" content="https://res.cloudinary.com/dynzcnjqf/image/upload/v1752399865/logo512_nxwint.png" />
      </Helmet>

      <main className="main-section">
        <div className="main-content">
          <div className="main-text">
            <h2>
              We make you <span className="inline-you">Successful</span>.<br />
              <img className="you-image" src={DesignImage} alt="u" loading="lazy" />
            </h2>
            <p style={{ color: "#2E0C6E" }}>
              Experience hands-on learning and stunning visuals that empower you to master
              <br />
              essential skills for a bright future!
            </p>
          </div>

          <img
            src={AnimationImage}
            alt="animation"
            className="right-image"
            loading="lazy"
          />
        </div>

        <div className="feature-section">
          <FeatureBox
            title="Learn & Understand"
            description="Explore practical and skill-based learning."
            buttonText="to the learning portal"
          />
          <FeatureBox
            title="Innovative Projects"
            description="Discover with real-world applications."
            buttonText="to the project portal"
          />
          <FeatureBox
            title="Jobs & Internships"
            description="Access opportunities that will help you grow."
            buttonText="to the job portal"
          />
        </div>
      </main>

      <Suspense fallback={<div>Loading sections...</div>}>
        <LearningSection />
        <Slider />
        <LearningExp />
        <Work />
        <MovingAnimation />
      </Suspense>

      <Suspense fallback={<div>Loading footer...</div>}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default HeroSection;
